import { State } from "@/types";

const state: State = {
  user: {
    username: null,
    email: null,
    emailVerified: null
  }
};

export default {
  namespaced: true,
  state,

  mutations: {
    setUser(state: any, userObj: any) {
      if (userObj) {
        state.username = userObj.displayName;
        state.email = userObj.email;
        state.emailVerified = userObj.emailVerified;
      } else {
        state.username = null;
        state.email = null;
        state.emailVerified = null;
      }
    }
  }
};
